
const rootStyle = {
  content: ' ',
  width: '100%',
  height: '100%',
  position: 'absolute',
} as React.CSSProperties;

const innerStyle = {
  height: '100%',
  width: '100%',
  '--circle-radius': '85px',
  '--border-width': '30px',
  '--mask': 'radial-gradient(ellipse farthest-side at center 45%, transparent var(--circle-radius), #000 calc(var(--circle-radius) + 2px) 100%) 50% 50%/100% 100% no-repeat',
  mask: 'var(--mask)',
  WebkitMask: 'var(--mask)',
  background: 'rgba(0,0,0,0.5)'
} as React.CSSProperties;

export default function VideoOverlay() {
  return (
    <div style={rootStyle} className="flex items-center justify-center">
      <div style={innerStyle}></div>
    </div>
  );
}
